import React from 'react';
import { LoginUpperRightLayout } from 'layout';
import { RestorePasswordExpired } from '@isyc-react/auth/modules/pods/login';
export const RestoreExpiredScene = () => {
    return (React.createElement(LoginUpperRightLayout, null,
        React.createElement(RestorePasswordExpired, null)));
};
